import { render, staticRenderFns } from "./SnapshotDetailSignRequestCard.vue?vue&type=template&id=91378fc8&scoped=true&"
import script from "./SnapshotDetailSignRequestCard.vue?vue&type=script&lang=ts&"
export * from "./SnapshotDetailSignRequestCard.vue?vue&type=script&lang=ts&"
import style0 from "./SnapshotDetailSignRequestCard.vue?vue&type=style&index=0&id=91378fc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91378fc8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardActions,VCardSubtitle,VIcon,VImg,VListItem,VListItemContent,VListItemIcon,VListItemTitle,VSpacer})
